<template>

  <div class="inline-flex">
    <!-- ********************** VIEW TYPE ********************** -->
    <aw-dropdown
      placement="bottom-start"
      :offset="[0, 6]"
      class="relative cursor-pointer"
    >
      <template v-slot:btn="{ toggle }">
        <div>
          <aw-icon
            @click="toggle"
            icon="gallery"
            class="w-4 h-4  mr-2.5 text-gray-400 hover:text-gray-500   cursor-pointer"
          ></aw-icon>
        </div>
      </template>
      <template v-slot:dropdown="{ opened, dropdown }">
        <div
          v-show="opened"
          :ref="dropdown"
          class="Dropdown Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
        >
          <div>
            <div class="p-4 relative" @click="changeType('gallery')">
              <div class="flex items-center">
                <aw-icon
                  icon="gallery"
                  class="w-6 h-6 cursor-pointer mr-2.5"
                  :class="{'text-bc-blue': element.type === 'gallery'}"
                ></aw-icon>
                <span class="flex-grow font-medium">{{$t('Gallery')}}</span>
                <span v-if="element.type === 'gallery'"
                  ><aw-icon
                    icon="tick"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
              <!-- todo translate ?-->
              <div class="pt-2 hidden">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Error, delectus
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
            <div class="p-4 relative" @click="changeType('files')">
              <div class="flex items-center">
                <aw-icon
                  icon="list"
                  class="w-6 h-6 cursor-pointer mr-2.5"
                  :class="{'text-bc-blue': element.type === 'files'}"
                ></aw-icon>
                <span class="flex-grow font-medium">List</span>
                <span v-if="element.type === 'files'"
                  ><aw-icon
                    icon="tick"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
              <!-- todo translate ?-->
              <div class="pt-2 hidden">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Error, delectus amet consectetur
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
            <div class="p-4 relative" @click="changeType('image')">
              <div class="flex items-center">
                <aw-icon
                  icon="rectangle"
                  class="w-6 h-6 cursor-pointer mr-2.5"
                  :class="{'text-bc-blue': element.type === 'image'}"
                ></aw-icon>
                <span class="flex-grow font-medium">{{$t('Image')}}</span>
                <span v-if="element.type === 'image'"
                    ><aw-icon
                      icon="tick"
                      class="relative w-6 h-6 -mx-1  text-bc-blue"
                    ></aw-icon
                  ></span>
              </div>
              <!-- todo translate ?-->
              <div class="pt-2 hidden">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Error, delectus amet consectetur
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
            <div class="p-4 relative" @click="changeType('preview')">
              <div class="flex items-center">
                <aw-icon
                  icon="preview"
                  class="w-6 h-6 cursor-pointer mr-2.5"
                  :class="{'text-bc-blue': element.type === 'preview'}"
                ></aw-icon>
                <span class="flex-grow font-medium">{{$t('Files with preview')}}</span>
                <span v-if="element.type === 'preview'"
                    ><aw-icon
                      icon="tick"
                      class="relative w-6 h-6 -mx-1  text-bc-blue"
                    ></aw-icon
                  ></span>
              </div>
              <!-- todo translate ?-->
              <div class="pt-2 hidden">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Error, delectus amet consectetur
              </div>
            </div>
          </div>
        </div>
      </template>
    </aw-dropdown>

    <!-- ********************** SORT TYPE **********************-->
    <aw-dropdown
      placement="bottom-start"
      :offset="[0, 6]"
      class="relative cursor-pointer"
    >
      <template #btn="{ toggle }">
        <div>
          <aw-icon
            @click="toggle"
            icon="sort-up-down"
            class="w-4 h-4  mr-2.5 text-gray-400 hover:text-gray-500   cursor-pointer"
            :class="{ 'text-bc-blue-raw' : (selectedSort && selectedSort !== 'rank')}"
          ></aw-icon>
        </div>
      </template>
      <template #dropdown="{ opened, dropdown, toggle }">
        <div
          v-show="opened"
          :ref="dropdown"
          class="Dropdown Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
        >
         <!-- Custom - by rank -->
          <div>
            <div class="p-4 relative" @click="changeSort('rank'), toggle()">
              <div class="flex items-center">
                <!-- <aw-icon
                  icon="gallery"
                  class="w-6 h-6 cursor-pointer mr-2.5  "
                  :class="{'text-bc-blue': selectedSort === 'custom'}"
                ></aw-icon> -->
                <span class="flex-grow font-medium">{{$t('Custom')}}</span>
                <span v-if="selectedSort === 'rank'"
                  ><aw-icon
                    icon="tick"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
          </div>
         <!-- Name - by name -->
          <div>
            <div class="p-4 relative" @click="changeSort('name'), toggle()">
              <div class="flex items-center">
                <!-- <aw-icon
                  icon="gallery"
                  class="w-6 h-6 cursor-pointer mr-2.5  "
                  :class="{'text-bc-blue': selectedSort === 'name'}"
                ></aw-icon> -->
                <span class="flex-grow font-medium">{{ $t('Name') }}</span>
                <span v-if="selectedSort === 'name'"
                  ><aw-icon
                    :icon="computedSortIcon"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
          </div>
         <!-- Added - by date added -->
          <div>
            <div class="p-4 relative" @click="changeSort('added'), toggle()">
              <div class="flex items-center">
                <!-- <aw-icon
                  icon="gallery"
                  class="w-6 h-6 cursor-pointer mr-2.5  "
                  :class="{'text-bc-blue': selectedSort === 'added'}"
                ></aw-icon> -->
                <span class="flex-grow font-medium">{{$t('Added')}}</span>
                <span v-if="selectedSort === 'added'"
                  ><aw-icon
                    :icon="computedSortIcon"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
          </div>
         <!-- Type - by extension -->
          <div>
            <div class="p-4 relative" @click="changeSort('ext'), toggle()">
              <div class="flex items-center">
                <!-- <aw-icon
                  icon="gallery"
                  class="w-6 h-6 cursor-pointer mr-2.5  "
                  :class="{'text-bc-blue': selectedSort === 'type'}"
                ></aw-icon> -->
                <span class="flex-grow font-medium">{{$t('Type')}}</span>

                <span v-if="selectedSort === 'ext'"
                  ><aw-icon
                    :icon="computedSortIcon"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
          </div>
         <!-- Type - by size -->
          <div>
            <div class="p-4 relative" @click="changeSort('size'), toggle()">
              <div class="flex items-center">
                <!-- <aw-icon
                  icon="gallery"
                  class="w-6 h-6 cursor-pointer mr-2.5  "
                  :class="{'text-bc-blue': selectedSort === 'type'}"
                ></aw-icon> -->
                <span class="flex-grow font-medium">{{$t('File size')}}</span>
                <span v-if="selectedSort === 'size'"
                  ><aw-icon
                   :icon="computedSortIcon"
                    class="relative w-6 h-6 -mx-1  text-bc-blue"
                  ></aw-icon
                ></span>
              </div>
            </div>
            <div class="border border-gray-200 border-t-0"></div>
          </div>
        </div>
      </template>
    </aw-dropdown>


    <!-- ********************** SETTINGS ********************** -->
    <aw-dropdown
      v-if="bcDocumentStore.edit"
      placement="bottom-start"
      :offset="[0, 6]"
      class="relative cursor-pointer"
    >
      <template v-slot:btn="{ toggle }">
        <div>
          <aw-icon
            @click="toggle"
            icon="cog"
            class="w-4 h-4  mr-2.5 text-gray-400 hover:text-gray-500   cursor-pointer"
          ></aw-icon>
        </div>
      </template>
      <template v-slot:dropdown="{ opened, dropdown }">
        <div
          v-show="opened"
          :ref="dropdown"
          class="Dropdown Dropdown--Hover absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow-md z-10"
        >
          <div>
            <toggle-button class="flex items-center cursor-pointer p-2" v-model="canDownload">
              <span class="ml-2.5 text-sm text-gray-500">
                {{$t('Enable downloads')}}
              </span>
            </toggle-button>
            <div class="border border-gray-200 border-t-0"></div>
            <toggle-button class="flex items-center cursor-pointer p-2" v-model="publicUpload">
              <span class="ml-2.5 text-sm text-gray-500">
                {{$t('Public upload')}}
              </span>
            </toggle-button>
            <div class="border border-gray-200 border-t-0"></div>
            <!-- <toggle-button class="flex items-center cursor-pointer p-2" v-model="connectCanva">
              <span class="ml-2.5 text-sm text-gray-500">
                {{$t('Connect with Canva')}}
              </span>
            </toggle-button> -->
          </div>
        </div>
      </template>
    </aw-dropdown>
  </div>

</template>
<script>
import FilesSort from '../../mixins/FilesSort'
// import Canva from '../../mixins/Canva'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

const elementTypeToIcon = {
  image: 'rectangle',
  files: 'list',
  gallery: 'gallery',
  preview: 'preview',
}

export default {
  mixins: [
    DocumentStore,
    FilesSort, 
    // Canva
  ],
  emits: ['update:modelValue'],
  props: {
    modelValue: Object,
  },
  data () {
    return {
      showSettings: false, 
    }
  },
  computed: {
    selectedViewIcon() {
      return elementTypeToIcon[this.element.type]
    },
    element: {
      get() {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    },
    canDownload: {
      get() {
        return this.element.data.can_download
      },
      set (val) {
        this.element.data.can_download = val
        this.element.children.forEach((el) => {
          el.data.can_download = val
        })
        this.element.updated = true
      }
    },
    publicUpload: {
      get() {
        return this.element.data.public_upload
      },
      set (val) {
        this.element.data.public_upload = val
        this.element.updated = true
      }
    },
    // connectCanva: {
    //   get() {
    //     return this.element.data.canva
    //   },
    //   set (val) {
    //     this.element.data.canva = val
    //     this.element.updated = true
    //   }
    // },
  },
  methods: {
    changeType (type) {
      this.element.type = type
      if (this.bcDocumentStore.edit) {
        this.element.updated = true
      }
    },
  },
  watch: {
    // connectCanva(val, oldVal) {
    //   if (val && !oldVal) {
    //     this.canva()
    //   }
    // }
  }
}
</script>